import { useHistory } from 'react-router-dom';
import { PlusOutlined } from '@ant-design/icons';
import { t } from '../../i18n/i18n';
import { CREATE_EVALUATION } from '../../constants/routes';
import './CreateEvaluationCard.scss';

const CreateEvaluationCard = () => {
  const history = useHistory();

  const handleCreateEvaluation = () => {
    history.push(CREATE_EVALUATION);
  };

  return (
    <div
      className="create-evaluation-card"
      role="button"
      tabIndex={0}
      onClick={handleCreateEvaluation}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleCreateEvaluation();
        }
      }}
      data-testid="create-evaluation-card-button"
    >
      <div className="create-card-content">
        <div className="plus-icon-container">
          <PlusOutlined className="plus-icon" />
        </div>
        <span className="create-card-text">{t('HOME_EMPTY_SEARCH_CREATE_EVALUATION')}</span>
      </div>
    </div>
  );
};

export default CreateEvaluationCard;
